import { render, staticRenderFns } from "./DialogLinkChannelsGlobal.vue?vue&type=template&id=664966e1&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./DialogLinkChannelsGlobal.vue?vue&type=script&lang=js"
export * from "./DialogLinkChannelsGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664966e1",
  null
  
)

export default component.exports